import { Swap } from '@velocity-exchange/icons';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import useSizeInputSource from 'src/components/TradeForm/SizeInput/hooks/useSizeInputSource';

export default function SizeUnitToggleButton() {
	const [, toggleSizeUnit] = useSizeInputSource();

	const handleToggle = () => {
		toggleSizeUnit((sizeUnit) => (sizeUnit === 'base' ? 'quote' : 'base'));
	};

	return (
		<IconButton
			size="sm"
			variant="tertiary"
			className="-m-sm p-sm"
			icon={Swap}
			onClick={handleToggle}
		/>
	);
}
